import { QSET_GENERATOR_RESULTS_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { Flex } from '@shared/components';

import type { QSetGeneratorResultStatistic } from '../../types';
import { SummaryStatsCard } from '../summary-stats-card';

export interface SummaryStatsGroupProps {
  data: QSetGeneratorResultStatistic;
}

export default function SummaryStatsGroup(props: Readonly<SummaryStatsGroupProps>) {
  const { data } = props;
  const {
    duplicationRate,
    totalQuestions,
    results: { total: totalQSetResults, totalPassed: totalPassedQSetResults },
  } = data;

  const totalDuplicatedQuestions = Math.ceil((duplicationRate / 100) * totalQuestions);
  const totalFailedQSetResults = totalQSetResults - totalPassedQSetResults;

  return (
    <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
      <SummaryStatsCard
        title='จำนวนชุดข้อสอบทั้งหมด'
        displayValue={`${totalQSetResults} ชุด`}
        additionalInfo={`(${totalQuestions} ข้อ/ชุด)`}
        displayValueTestId={QSET_GENERATOR_RESULTS_DATA_TEST_ID.TOTAL_QSETS_VALUE_TEXT}
      />
      <SummaryStatsCard
        title='ค่าความซ้ำที่กำหนด'
        displayValue={`${duplicationRate.toFixed(2)}%`}
        additionalInfo={`(${totalDuplicatedQuestions} ข้อ)`}
        displayValueTestId={QSET_GENERATOR_RESULTS_DATA_TEST_ID.DUPLICATION_RATE_VALUE_TEXT}
      />
      <SummaryStatsCard
        title='ผ่านเกณฑ์'
        displayValue={`${totalPassedQSetResults} ชุด`}
        cardColor='success'
        displayValueTestId={QSET_GENERATOR_RESULTS_DATA_TEST_ID.PASSED_VALUE_TEXT}
      />
      <SummaryStatsCard
        title='ไม่ผ่านเกณฑ์'
        displayValue={`${totalFailedQSetResults} ชุด`}
        cardColor='error'
        displayValueTestId={QSET_GENERATOR_RESULTS_DATA_TEST_ID.FAILED_VALUE_TEXT}
      />
    </Flex>
  );
}
